import { IconPV } from '@/components/Icon/IconPV';
import { IconStorageClass } from '@/components/Icon/IconStorageClass';
import { getPathnameForContextParsing } from '@/utils/pathContext';

export const getClusterPrefix = () => {
  const [, var0, name1, var1, name2, var2, name3] = getPathnameForContextParsing().split('/');
  const obj = {
    [var0]: name1,
    [var1]: name2,
    [var2]: name3,
  };
  let prefix = obj.subcluster ? `/cluster/${obj.cluster}/subcluster/${obj.subcluster}` : `/cluster/${obj.cluster}`;
  const currCluster = obj.subcluster || obj.cluster;
  if (obj.wsp) {
    prefix = `/wsp/${obj.wsp}` + prefix;
  }
  return { prefix, cluster: currCluster };
};

export const getClusterMenu = () => {
  const { prefix } = getClusterPrefix();
  return [
    {
      title: 'cluster',
      icon: 'icon-jiqun',
      children: [
        // 概览
        {
          title: 'clusterOverview',
          icon: 'icon-gailan',
          path: `${prefix}/base-info`,
          isLeaf: true,
        },
        //   集群信息
        {
          title: 'clusterInfo',
          menu: 'top',
          icon: 'icon-jiqunguanli',
          children: [
            {
              title: 'clusterNodes',
              path: `${prefix}/all/nodes`,
              icon: 'icon-jiqunjiedian',
              isLeaf: true,
            },
            {
              title: 'clusterMonitoring',
              path: `${prefix}/cluster-condition`,
              icon: 'icon-jiqunzhuangtai',
              isLeaf: true,
            },
          ],
        },
        //命名空间
        {
          title: 'namespaces',
          path: `${prefix}/namespaces`,
          icon: 'icon-xiangmu',
          isLeaf: true,
        },
        // 应用负载
        {
          title: 'application',
          icon: 'icon-yingyongfuzai',
          menu: 'top',
          children: [
            /** ============================ 工作负载 ==================================== */
            {
              title: 'workloads',
              path: `${prefix}/workload/`,
              icon: 'icon-bushu',
              isLeaf: true,
            },
            /** ============================ 容器组 ==================================== */
            {
              title: 'pods',
              path: `${prefix}/pods`,
              icon: 'icon-rongqizu',
              isLeaf: true,
            },
            /** ============================ 服务 ==================================== */
            {
              title: 'services',
              path: `${prefix}/service`,
              icon: 'icon-service',
              isLeaf: true,
            },
          ],
        },
        //配置
        {
          title: 'configuration',
          icon: 'icon-peizhizidian',
          menu: 'top',
          children: [
            {
              title: 'secrets',
              path: `${prefix}/secrets`,
              icon: 'icon-baomizidian',
              isLeaf: true,
            },

            {
              title: 'configMaps',
              path: `${prefix}/configmaps`,
              icon: 'icon-peizhizidian',
              isLeaf: true,
            },
          ],
        },
        // 存储
        {
          title: 'storage',
          icon: 'icon-cunchu',
          children: [
            {
              title: 'pvc',
              path: `${prefix}/pvcs`,
              icon: 'icon-chijiujuanshengming',
              isLeaf: true,
            },
            {
              title: 'pv',
              path: `${prefix}/pvs`,
              isLeaf: true,
              icon: IconPV,
            },
            {
              title: 'storageClasses',
              path: `${prefix}/storageclasses`,
              icon: IconStorageClass,
              isLeaf: true,
            },
          ],
        },
      ],
    },
  ];
};
